<app-header [label]="selected_item?.id ? 'Update Country' : 'Add Country'"></app-header>
<div class="rounded-2xl border border-[#E4E7EC] flex flex-col w-full relative mb-4 h-[calc(100%-90px)]">
  <div class="flex h-full overflow-y-auto no-scrollbar flex-col bg-white rounded-2xl shadow w-full">
    <form [formGroup]="form">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 pb-24">
        <app-text-input [is_required]="true" class="w-full" label="Country Name" formControlName="name"></app-text-input>
        <app-text-input [is_required]="true" type="number" class="w-full" [code]="true" label="Country Code" formControlName="code"></app-text-input>
      </div>
    </form>
    <div class="flex absolute rounded-b-2xl px-6 py-4 items-center justify-end gap-4 w-full bottom-0 bg-white">
      <app-button color="border-gray-300 text-gray-700 font-medium" label="Discard" type="button" (click)="discard()"></app-button>
      <app-button color="bg-primary text-white" [label]="selected_item?.id ? 'Update' : '+ Add'" type="button" [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
    </div>
  </div>
</div>
